import { GetterTree } from 'vuex';
import { UserSettingState, UserSetting } from './types';
import { RootState } from '../../types';

const getUserSettings = state => (): UserSetting => state.userSetting;

export const getters: GetterTree<UserSettingState, RootState> = {
    userSetting: state => getUserSettings(state),
};
